import React, { useMemo, useCallback, useState } from 'react';
import Preparations from './preparations/Preparations';
import Presentation from './presentations/Presentations';
import styles from './SidebarUnit.module.scss';
import { ExtendedUnitFragment, LessonType as TeacherLessonType,
  Content, Lesson, useGetUnitLazyQuery, LastVisitedLessonContentFragment } from '@api/graphql-codegen';
import ArrowTop from 'src/assets/icons/chewron_top.svg?react';
import { useCourseContent } from '@hooks/useCourseContent';
import Spinner from '@components/spinner/Spinner';
import { sortByPosition, sortByNumber } from '@utils/helpers';

interface SidebarUnitProps {
  unit: ExtendedUnitFragment;
  lastVisitedLesson?: LastVisitedLessonContentFragment;
  isParentApp?: boolean;
}

const SidebarUnit = ({ unit, lastVisitedLesson, isParentApp }: SidebarUnitProps) => {
  const [opened, setOpened] = useState(false);
  const { setCurrentUnit } = useCourseContent();
  const [ getUnitInfo, { data, loading } ] = useGetUnitLazyQuery();

  const tpreps = useMemo(() => [...data?.getUnitInfo?.teacherPreparation || []].sort(sortByPosition), [data?.getUnitInfo?.teacherPreparation]);
  const cpres = useMemo(() => [...data?.getUnitInfo?.classPresentation || []].sort(sortByNumber), [data?.getUnitInfo?.classPresentation]);

  const listwrapper = useMemo(() => (opened ? [styles.wrapper, styles.opened] : [styles.wrapper]).join(' '), [opened]);

  const handleUnitClick = useCallback(async (e : React.SyntheticEvent) => {
    e.stopPropagation();
    if (loading) {
      return;
    }
    if (!opened) {
      const result = await getUnitInfo({ variables: { input: { id: unit.id } }});
      if (result?.data?.getUnitInfo) {
        setCurrentUnit(result.data?.getUnitInfo);
      }
    }
    setOpened(state => !state);
  }, [getUnitInfo, loading, opened, setCurrentUnit, unit.id]);

  return (
    <div className={listwrapper}>
      <section onClick={handleUnitClick} className={styles.header}>
        <div className={styles.headerContent}>
          <div className={styles.title}>{unit?.name || ''}</div>
        </div>
        <div>
          {loading ? <div className={styles.loading}><Spinner width={20} height={20} /></div> : null}
        </div>
        <div className={styles.iconWrapper} onClick={handleUnitClick}>
          <ArrowTop className={styles.icon}/>
        </div>
      </section>
      <section className={styles.list}>
        <Preparations
          lessonOpened={false}
          lessonType={TeacherLessonType.PREPARATION}
          lesson={undefined}
          contents={tpreps as Content[]}
          title={'Teacher Preparation'}
        />
        <Presentation
          lessons={cpres as Lesson[]}
          title={'Class Presentation'}
          lastVisitedLesson={lastVisitedLesson}
          isParentApp={isParentApp}
        />
      </section>
    </div>
  )
}

export default SidebarUnit;
